import { useSuspenseQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { roomQueries } from '@/entities/room'

type RoomSchedulesParams = {
  roomId: number
  year: number
  month: number
}

export const useRoomSchedules = (params: RoomSchedulesParams) => {
  const { data } = useSuspenseQuery({
    ...roomQueries.roomSchedules(params),
    select: res => res.schedules,
    meta: {
      useCustomHandling: true,
    },
  })

  const blockedDates = useMemo(() => {
    return data.map(schedule => new Date(schedule.date))
  }, [data])

  return {
    schedules: data || [],
    blockedDates,
  }
}
